function getURLParameter(name, defaultValue) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function getCookie(name) {
  var value = document.cookie;
  var start = value.indexOf(" " + name + "=");
  if (start == -1) {
    start = value.indexOf(name + "=");
    if (start > 1) start = -1;
  }
  if (start == -1) {
    value = null;
  } else {
    start = value.indexOf("=", start) + 1;
    var end = value.indexOf(";", start);
    if (end == -1) {
      end = value.length;
    }
    value = unescape(value.substring(start, end));
  }
  return value;
}

function setCookie(name, value, opt_params) {
  opt_params = opt_params || {};
  var expiry = new Date();
  if (opt_params.minutes) {
    setMinutes(expiry.getMinutes() + opt_params.minutes);
  } else if (opt_params.hours) {
    setHours(expiry.getHours() + opt_params.hours);
  } else {
    var days = opt_params.days || 30;
    expiry.setDate(expiry.getDate() + days);
  }
  document.cookie = name + "=" + value + ";expires=" + (opt_params.sessionExpiry ? "" : expiry.toGMTString()) + ";path=" + (opt_params.path || "/") + ";domain=" + (opt_params.domain || getTopLevelDomain());

  // convenience functions
  function setHours(hours) {
    if (hours > 23) {
      expiry.setDate(expiry.getDate() + 1);
      expiry.setHours(hours % 23);
    } else {
      expiry.setHours(hours);
    }
  }
  function setMinutes(minutes) {
    if (minutes > 59) {
      setHours(expiry.getHours() + 1);
      expiry.setMinutes(minutes % 59);
    } else {
      expiry.setMinutes(minutes);
    }
  }
}

function getTopLevelDomain() {
  var domains = document.domain.split(".").reverse();
  var cookie = "__test__";
  var domain = domains[0];
  for (var i = 0; i < domains.length; i++) {
    document.cookie = cookie + "=__test__;path=/;domain=" + domain;
    if (getCookie(cookie) != null) {
      document.cookie = cookie + "=;expires=Thu, 01-Jan-1970 00:00:01 GMT;path=/;domain=" + domain;
      return domain;
    } else {
      domain = domains[i+1] + "." + domain;
    }
  }
}

function getLastTouchCampaignSource() {
  return getLastTouchCampaignValue("utmcsr");
}

function getLastTouchCampaignMedium() {
  return getLastTouchCampaignValue("utmcmd");
}

function getLastTouchCampaignName() {
  return getLastTouchCampaignValue("utmccn");
}

function getLastTouchCampaignContent() {
  return getLastTouchCampaignValue("utmcct");
}

function getLastTouchCampaignValue(campaignCookiePart) {
  if (!campaignCookiePart) return;
  var lastTouchCampaignCookie = getLastTouchCampaignCookie();
  var campaignValue = lastTouchCampaignCookie && lastTouchCampaignCookie.match(new RegExp(campaignCookiePart + "=([^|]*)"));
  return campaignValue && campaignValue[1];
}

function getLastTouchCampaignCookie() {
  var lastTouchCampaignCookie = getCookie("__pc__LT");

  // Campaign data
  var campaignSource = "";
  var campaignMedium = "";
  var campaignName = "";
  var campaignKeyword = "";
  var campaignContent = "";

  // Search engines
  var searchEngines = ["google", "yahoo", "bing", "aol", "ask", "yandex", "baidu", "naver", "msn"];
  var searchEnginesRegExp = new RegExp(searchEngines.join("|"), "i");

  // Determine values for campaign data
  if (getURLParameter("utm_source") && getURLParameter("utm_medium")) {
    campaignSource = getURLParameter("utm_source");
    campaignMedium = getURLParameter("utm_medium");
    campaignName = getURLParameter("utm_campaign");
    campaignKeyword = getURLParameter("utm_term");
    campaignContent = getURLParameter("utm_content");
  } else if (getURLParameter("gclid")) {
    campaignSource = "google";
    campaignMedium = "cpc";
  } else if (searchEnginesRegExp.test(document.referrer)) {
    for (var i = 0; i < searchEngines.length; i++) {
      var searchEngine = searchEngines[i];
      var searchEngineRegExp = new RegExp(searchEngine, "i");
      if (searchEngineRegExp.test(document.referrer)) {
        campaignSource = searchEngine;
        campaignMedium = "organic";
        break;
      }
    }
  } else if (document.referrer) {
    var domain = getTopLevelDomain();
    var domainRegExp = new RegExp(domain.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"), "i");
    if (!domainRegExp.test(document.referrer)) {
      campaignSource = document.referrer.match(/\/\/([^/?&#]*)/)[1].replace(/^www\./, '');
      campaignMedium = "referral";
    }
  } else if (!lastTouchCampaignCookie) {
    campaignSource = "(direct)";
    campaignMedium = "(none)";
  }

  if (campaignSource && campaignMedium) {
    // Set first touch campaign cookie values
    lastTouchCampaignCookie = [
      "utmcsr=" + campaignSource.toLowerCase(),
      "utmcmd=" + campaignMedium.toLowerCase(),
      "utmccn=" + campaignName,
      "utmctr=" + campaignKeyword,
      "utmcct=" + campaignContent
    ].join("|");
    setCookie("__pc__LT", lastTouchCampaignCookie);
  }

  return lastTouchCampaignCookie;
}

function getGAVisitorId() {
  var visitorCookie = getCookie("_ga");
  if (visitorCookie) {
    var cookieParts = visitorCookie.split(".");
    if (cookieParts.length > 3) {
      return cookieParts[2] + "." + cookieParts[3];
    }
  }
  return "";
}

$(document).ready(function() {
  window.lastTouchCampaignCookie = getLastTouchCampaignCookie();
});